import AddInvoiceEntry from '../AddInvoiceEntry'

export default function RedInvoiceDetail() {
  return <AddInvoiceEntry pageType="RED" />
}
import AddInvoiceEntry from '../AddInvoiceEntry'

export default function RedInvoiceDetail() {
  return <AddInvoiceEntry pageType="RED" />
}
